import _ from 'lodash';
import GraphqlBuilder from "utils/request/graphql/builder";
import { bookingStatus } from 'utils/constants/booking-constants'
import QueryBookingsValidation from 'graphql/queries/management/QueryBookingsValidation'

const FetchManagementBookingsValidation = {

	fetch: ( { building = {}, date, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		const graphqlBuilder = new GraphqlBuilder();

		const buildingGuid = _.get( building, 'guid', null );

		graphqlBuilder
			.addQuery( 'employee_bookings_validation', QueryBookingsValidation, {
				building_guid: buildingGuid,
				booking_date: date,
				status: [
					bookingStatus.MANUAL_VALIDATION
				]
			})
			.setResultPath( ['employee_bookings_validation', 'employee_bookings'], {} )
			.setOnStart( () => {
				return FetchManagementBookingsValidation.onStart(callbackStart);
			} )
			.setOnError( result => {
				return FetchManagementBookingsValidation.onError(result, callbackError);
			} )
			.setOnSuccess( result => {
				return FetchManagementBookingsValidation.onSuccess(result, callbackSuccess);
			} )
			.execute();
	},
	
	onError: ( result, callbackError = null ) => {
		if( callbackError !== null && _.isFunction( callbackError ) ) {
			callbackError( result );
		}
	},

	onStart: ( callbackStart = null ) => {
		if( callbackStart !== null && _.isFunction( callbackStart ) ) {
			callbackStart();
		}
	},

	/**
	 * Function for creating the occupied timeslots by employee guid
	 * @param result
	 * @param callbackSuccess
	 */
	onSuccess: ( result, callbackSuccess = null ) => {
		if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
			callbackSuccess( result );
		}
	},
}

export default FetchManagementBookingsValidation
